'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _analyticsJs = require('@zg-rentals/analytics-js');

var ZG_RENTALS_AUTH_REDIRECT_TRACKER = 'ZG_RENTALS_AUTH_REDIRECT_TRACKER';
var redirectAlertInterval = 3 * 60 * 1000; // Three minutes

var AuthRedirectEvent = function AuthRedirectEvent() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        loggedIn = _ref.loggedIn,
        userToken = _ref.userToken,
        email = _ref.email,
        hasStrongAuthentication = _ref.hasStrongAuthentication,
        redirectTo = _ref.redirectTo,
        _ref$time = _ref.time,
        time = _ref$time === undefined ? Date.now() : _ref$time,
        _ref$userAgent = _ref.userAgent,
        userAgent = _ref$userAgent === undefined ? navigator.userAgent : _ref$userAgent;

    return {
        loggedIn: loggedIn,
        userToken: userToken,
        email: email,
        hasStrongAuthentication: hasStrongAuthentication,
        redirectTo: redirectTo,
        time: time,
        userAgent: userAgent
    };
};

function trackAuthRedirect(_ref2) {
    var userToken = _ref2.userToken,
        loggedIn = _ref2.loggedIn,
        email = _ref2.email,
        hasStrongAuthentication = _ref2.hasStrongAuthentication,
        redirectTo = _ref2.redirectTo;

    if (!userToken || !window) {
        // We care most about cases when we know the userId but he is still somehow redirected.
        // If we don't know the userId then most likely he hasn't signed in, and we won't know
        // if it is the same user anyway when we see multiple redirects.
        // We only run this code on client, so we need to make sure window exists
        return;
    }

    var authRedirectTracker = window.sessionStorage.getItem(ZG_RENTALS_AUTH_REDIRECT_TRACKER);
    if (!authRedirectTracker) {
        authRedirectTracker = {};
    } else {
        try {
            authRedirectTracker = JSON.parse(authRedirectTracker);
        } catch (error) {
            (0, _analyticsJs.feLog)({
                alertLevel: _analyticsJs.ALERT_LEVEL.FE_ERROR,
                page: window.location,
                event: 'Parse ZG_RENTALS_AUTH_REDIRECT_TRACKER from sessionStorage',
                message: 'failed to parse ZG_RENTALS_AUTH_REDIRECT_TRACKER from sessionStorage.',
                stacktrace: error
            });
            authRedirectTracker = {};
        }
    }

    var authRedirectEvents = authRedirectTracker[userToken];

    if (!authRedirectEvents) {
        authRedirectEvents = [];
    }

    authRedirectEvents.push(AuthRedirectEvent({ userToken: userToken, loggedIn: loggedIn, email: email, hasStrongAuthentication: hasStrongAuthentication, redirectTo: redirectTo }));

    if (authRedirectEvents.length === 4) {
        // We always add to the end of the array and deletes from the beginning, so we make sure
        // their order is sorted.
        var firstEventTime = authRedirectEvents[0].time;
        var lastEventTime = authRedirectEvents[3].time;

        if (lastEventTime - firstEventTime <= redirectAlertInterval) {
            try {
                (0, _analyticsJs.feLog)({
                    alertLevel: _analyticsJs.ALERT_LEVEL.FE_ERROR,
                    page: window.location,
                    event: 'User stuck in an auth loop',
                    message: 'User stuck in an auth loop, more details: ' + JSON.stringify(authRedirectEvents)
                });
            } catch (error) {
                (0, _analyticsJs.feLog)({
                    alertLevel: _analyticsJs.ALERT_LEVEL.FE_ERROR,
                    page: window.location,
                    event: 'Stringify authRedirectEvents',
                    message: 'failed to stringify authRedirectEvents',
                    stacktrace: error.stack
                });
            }
        }

        authRedirectEvents.shift();
    }

    authRedirectTracker[userToken] = authRedirectEvents;

    try {
        window.sessionStorage.setItem(ZG_RENTALS_AUTH_REDIRECT_TRACKER, JSON.stringify(authRedirectTracker));
    } catch (error) {
        (0, _analyticsJs.feLog)({
            alertLevel: _analyticsJs.ALERT_LEVEL.FE_ERROR,
            page: window.location,
            event: 'Stringify ZG_RENTALS_AUTH_REDIRECT_TRACKER and store to sessionStorage',
            message: 'failed to stringify ZG_RENTALS_AUTH_REDIRECT_TRACKER and store to sessionStorage',
            stacktrace: error
        });
    }
}

exports.default = trackAuthRedirect;